import AV from 'leancloud-storage';

AV.init({
  appId: "LmuGxUyCrapDprypAG24J5jm-gzGzoHsz",
  appKey: "23hApYZ2PhFzurkOu51ihkix",
  serverURL: "https://lmugxuyc.lc-cn-n1-shared.com",
  masterKey: 'PtONBSzMIiilKZh3fQhgwDkQ'
});

export default AV;